// extracted by mini-css-extract-plugin
export default {"whatStudentsLearn":"styles_whatStudentsLearn__MiyVl","keyDetailsDesc":"styles_keyDetailsDesc__D22rz","keyTopicsList":"styles_keyTopicsList__CEgpO","icon":"styles_icon__wBEpX"};